import { generatePath, useNavigate } from 'react-router-dom';
import styles from './profile-2-chat-btn.module.scss';
import { routesApp } from '@/constans/routes';
import { OpenChatIcon } from '@/assets/icons';
import clsx from 'clsx';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';

interface Props {
    chatId: number;
    className?: string;
}

export const Profile2ChatBtn: React.FC<Props> = ({ chatId, className }) => {
    const navigate = useNavigate();

    return (
        <button
            className={
                clsx(
                    styles.openChatBtn,
                    className
                )
            }
            onClick={() => {
                callYaMetrika('msg_button_from_profile_viewing')
                eventsApi.updateUserEvent('msg_button_from_profile_viewing')
                navigate(
                    generatePath(
                        routesApp.chat,
                        { id: String(chatId) }
                    )
                )
            }}>
            <OpenChatIcon
                width={24}
                height={24} />
        </button>
    )
}
